// DEV-2684 Adım 6B — "Kullanıcı İzinleri" ekranının yetki matrisi için GÖSTERİM verisi.
//
// ⭐ KANONİK BAĞ (DEMİR KURAL #11 / DEV-2684 D7): matris satır kümesi ve kademe varsayılanı
// TAMAMEN SUNUCUDAN gelir. `GET roles/{role}/modul-yetkileri` 49 tablo-modülünün tamamını
// (`gizli` varsayılanı + `urun` + `ust` ile) döndürür; ekran yalnız sunucunun döndürdüğü
// satırları çizer, istemci hiçbir modül EKLEMEZ (KullaniciIzinleriMatris.vue). Bu dosya yalnız
// GÖSTERİM düzenini taşır: etiket, ürün grubu, sıra ve alt başlık ağacı. Sunucudan gelip bu
// ağaçta olmayan ya da ağaçta olup sunucudan gelmeyen modül ekranda görünür bir uyarı üretir
// (kopya değil, kayma tespiti). Kademe değerleri backend KademeEnum ile aynı olmak zorundadır;
// eşleşme bozulursa PUT modul-yetkileri 422 döner (RolModulYetkiServisi::dogrula).
//
// ⚠ Bağımlılık kuralları (Kural 1/2/3) ALT-ÜST ilişkisini bu ağaçtan DEĞİL, sunucunun her
// satırda döndürdüğü `ust` alanından okur (addan türetme yasak — DEMİR KURAL #11). Bu ağaç
// yalnız çizim düzenidir; aile bağı config/yetki_modulleri.php'deki `ust`'tur.
//
// Matris satırları = config'te kaynak='tablo' olan 49 modül (aktar-modulu spatie kaynaklı
// olduğu için matriste YOKTUR — K5, sunucu kapısı yok, /ben Spatie izninden türetir).

/** rol_modul_yetkileri.kademe değerleri (KademeEnum ile aynı, en kısıtlıdan en genişe). */
export enum YetkiKademe {
  GIZLI = "gizli",
  GORUNUR_KAPALI = "gorunur_kapali",
  GORUNTULE = "goruntule",
  DUZENLE = "duzenle",
}

/** Segment düğmelerinde gösterilecek kademe seçenekleri (soldan sağa artan yetki). */
export const KADEME_SECENEKLERI: Array<{ value: YetkiKademe; label: string; icon: string }> = [
  { value: YetkiKademe.GIZLI, label: "Gizli", icon: "mdi-eye-off-outline" },
  { value: YetkiKademe.GORUNUR_KAPALI, label: "Görünür-Kapalı", icon: "mdi-lock-outline" },
  { value: YetkiKademe.GORUNTULE, label: "Görüntüle", icon: "mdi-eye-outline" },
  { value: YetkiKademe.DUZENLE, label: "Düzenle", icon: "mdi-pencil-outline" },
];

/**
 * Kademe sıralaması (en kısıtlı=0 ... en geniş=3). Bağımlılık kuralları "en az Görüntüle"
 * karşılaştırmasını bu haritadan yapar; backend YetkiDenetcisi ile aynı sıralama.
 */
export const KADEME_SIRA: { [k in YetkiKademe]: number } = {
  [YetkiKademe.GIZLI]: 0,
  [YetkiKademe.GORUNUR_KAPALI]: 1,
  [YetkiKademe.GORUNTULE]: 2,
  [YetkiKademe.DUZENLE]: 3,
};

/** `kademe` değeri `enAz` kademesine eşit ya da daha geniş mi (ör. "en az Görüntüle"). */
export function kademeEnAz(kademe: string | YetkiKademe, enAz: YetkiKademe): boolean {
  return (KADEME_SIRA[kademe as YetkiKademe] ?? 0) >= KADEME_SIRA[enAz];
}

/**
 * Rol kartı renk paleti (DEV-2684 görsel tasarım). Rol listesi dinamik olduğundan renk
 * ROL İNDEKSİNE göre atanır (index paleti aşarsa başa döner). İlk rol (genelde Sistem
 * Yöneticisi) mor; sıradaki renkler ayırt edilebilir tonlardır.
 */
export const ROL_RENK_PALETI: string[] = [
  "#7C3AED", "#3B82F6", "#10B981", "#F59E0B",
  "#F97316", "#EC4899", "#06B6D4", "#8B5CF6",
];

/** Rolü/ataması olmayan durumlar için nötr gri (avatar vb.). */
export const NOTR_ROL_RENGI = "#9CA3AF";

/** Rol indeksine göre palet rengini döndürür (taşarsa baştan döner). */
export function rolRengi(index: number): string {
  if (index < 0) {
    return ROL_RENK_PALETI[0];
  }
  return ROL_RENK_PALETI[index % ROL_RENK_PALETI.length];
}

/**
 * Modül ANAHTARI -> mdi ikon eşlemesi (etikete göre DEĞİL; anahtar kanonik, DEMİR KURAL #11).
 * Ağaçta görünen HER modül (üst + alt) için gösterim ikonu. Eşlenmemiş anahtar
 * `mdi-cog-outline`'a düşer. Spec testi ağaçtaki her modülün burada ikonu olmasını ve
 * ağaçta karşılığı olmayan ölü anahtar bulunmamasını zorlar.
 */
export const MODUL_IKONLARI: { [modul: string]: string } = {
  // OfisPro — üst modüller
  "buro-modulu": "mdi-office-building",
  "vekalet-modulu": "mdi-file-document-outline",
  "rapor-modulu": "mdi-chart-box-outline",
  "dilekce-modulu": "mdi-file-edit-outline",
  "kasa-modulu": "mdi-cash-register",
  "ajanda-modulu": "mdi-calendar-month-outline",
  "tercih-modulu": "mdi-shield-account-outline",
  "islem-kaydi": "mdi-history",
  "istatistikler-modulu": "mdi-chart-bar",
  "uyarilar-modulu": "mdi-bell-outline",
  "hesaplamalar": "mdi-calculator-variant-outline",
  // OfisPro — alt modüller
  "buro-calisanlar": "mdi-account-multiple-outline",
  "buro-bilgileri": "mdi-office-building-outline",
  "ajanda-is-listesi": "mdi-clipboard-list-outline",
  "ajanda-is-sablonlari": "mdi-clipboard-text-multiple-outline",
  "vekalet-avukat-bilgileri": "mdi-badge-account-outline",
  // İcraPro — üst modüller
  "takip-ac": "mdi-file-plus-outline",
  "takip-listesi": "mdi-format-list-numbered",
  "takip-bilgisi": "mdi-information-outline",
  "borclular": "mdi-account-group-outline",
  "takip-alacaklar-goruntule": "mdi-cash-multiple",
  "takip-kapak-hesabi-goruntule": "mdi-file-table-outline",
  "takip-dokuman": "mdi-file-multiple-outline",
  "takip-notlari-goruntule": "mdi-note-text-outline",
  "alacaklilar": "mdi-account-tie-outline",
  "tercihler-modulu": "mdi-tune-variant",
  "faiz-hesaplama-modulu": "mdi-percent-outline",
  "toplu-xml-indir": "mdi-xml",
  // İcraPro — Borçlular alt modülleri
  "borclular-haciz": "mdi-gavel",
  "borclular-satis": "mdi-sale",
  "borclular-tebligat": "mdi-email-outline",
  "borclular-borclu-vekili": "mdi-account-tie",
  // İcraPro — Kapak Hesabı alt modülleri
  "kapak-hesabi-masraf-harc": "mdi-file-document-minus-outline",
  "kapak-hesabi-tahsilat-taksit": "mdi-calendar-clock-outline",
  // İcraPro — Tercihler alt modülleri
  "tercihler-takip-durumlari": "mdi-list-status",
  "tercihler-takip-alt-tipleri": "mdi-shape-outline",
  "tercihler-takip-ek-alanlari": "mdi-form-textbox",
  "tercihler-alt-tahsilat-turleri": "mdi-cash-plus",
  "tercihler-not-sablonlari": "mdi-note-multiple-outline",
  "tercihler-faiz-turleri": "mdi-percent-box-outline",
  "tercihler-masraf-cesitleri": "mdi-cash-minus",
  "tercihler-vekalet-ucretleri": "mdi-scale-balance",
  "tercihler-harclar": "mdi-receipt-text-outline",
  "tercihler-not-ayarlari": "mdi-note-edit-outline",
  // Ortak Kayıt İzinleri
  "ortak-adres": "mdi-map-marker-outline",
  "ortak-iletisim": "mdi-phone-outline",
  "ortak-banka-hesabi": "mdi-bank-outline",
  "ortak-dokuman": "mdi-folder-file-outline",
  "ortak-vekalet-kaydi": "mdi-file-sign",
};

/** Modül anahtarının gösterim ikonunu döndürür; eşleşme yoksa genel `mdi-cog-outline`. */
export function modulIkonu(modul: string): string {
  return MODUL_IKONLARI[modul] || "mdi-cog-outline";
}

/** Matriste tek bir modül satırının UI durumu. */
export interface ModulYetkiSatiri {
  modul: string;
  kademe: YetkiKademe;
  ekle: boolean;
  degistir: boolean;
  sil: boolean;
  // Sunucunun döndürdüğü ürün grubu ("ofis-pro" / "icra-pro" / "ortak" / ...). Ağaçta olmayan
  // bir modül gösterim ağacında doğru ürün başlığı altına bu alanla yerleştirilir (DEV-2684 D7).
  urun?: string | null;
  // Sunucunun döndürdüğü ekran adı (API config `etiket`); eski sunucuda yoktur (bkz. modulEtiketi).
  etiket?: string | null;
  // Sunucunun döndürdüğü ÜST modül anahtarı (yoksa null). Bağımlılık kuralları aile bağını
  // addan değil bu alandan okur (DEMİR KURAL #11).
  ust?: string | null;
}

/** Ağaçtaki bir düğüm: bir modül satırı, altında (varsa) alt başlıklar (n-seviye). */
export interface ModulDugumu {
  modul: string;
  // Ekranda gösterilen ad. Kanonik ağaçta (MODUL_AGACI) YOKTUR: ad API'den (`etiket`) gelir ve
  // gösterim ağacı kurulurken doldurulur (matris + kişiye özel yetki modalı aynı kaynağı kullanır).
  label?: string;
  cocuklar?: ModulDugumu[];
}

/**
 * Modül adının tek kaynağı API'dir (`config/yetki_modulleri.php` -> `etiket`, yanıtta her satırda).
 * Geçiş dönemi: API `etiket` göndermezse ham anahtar ("buro-calisanlar") yerine okunur bir ad
 * üretilir ("Buro Calisanlar"); bu yalnız yedektir, gerçek ad API'den gelir.
 */
export function modulEtiketi(modul: string, etiket?: string | null): string {
  if (etiket && etiket.trim() !== "") {
    return etiket;
  }
  return modul
    .split("-")
    .filter((parca) => parca !== "")
    .map((parca) => parca.charAt(0).toLocaleUpperCase("tr") + parca.slice(1))
    .join(" ");
}

/** Ürün grubu: OfisPro / İcraPro / Ortak (sunucudan gelen bilinmeyen bir ürün için "diger"). */
export interface UrunGrubu {
  urun: string;
  baslik: string;
  dugumler: ModulDugumu[];
}

/**
 * Ürün köküne göre gruplanmış kanonik modül ağacı (yalnız GÖSTERİM düzeni).
 *
 * Alt başlıklar n-seviyeli olabilir: "Takip Listesi" altındaki "Borçlular" ve "Kapak Hesabı"
 * kendi alt başlıklarını taşır (3 seviye). Her alt başlık config'te kaynak='tablo' olan ayrı
 * bir modüle karşılık gelir ve ayrı ayrı ayarlanabilir. Üst-level modül SIRASI mevcut gösterim
 * düzenini korur; alt başlık sırası backend config'teki `ust` sırasıyla aynıdır.
 */
export const MODUL_AGACI: UrunGrubu[] = [
  {
    urun: "ofis-pro",
    baslik: "OfisPro",
    dugumler: [
      {
        modul: "buro-modulu",
        cocuklar: [
          { modul: "buro-calisanlar" },
          { modul: "buro-bilgileri" },
        ],
      },
      {
        modul: "vekalet-modulu",
        cocuklar: [
          { modul: "vekalet-avukat-bilgileri" },
        ],
      },
      { modul: "rapor-modulu" },
      { modul: "dilekce-modulu" },
      { modul: "kasa-modulu" },
      {
        modul: "ajanda-modulu",
        cocuklar: [
          { modul: "ajanda-is-listesi" },
          { modul: "ajanda-is-sablonlari" },
        ],
      },
      { modul: "tercih-modulu" },
      { modul: "islem-kaydi" },
      { modul: "istatistikler-modulu" },
      { modul: "uyarilar-modulu" },
      { modul: "hesaplamalar" },
    ],
  },
  {
    urun: "icra-pro",
    baslik: "İcraPro",
    dugumler: [
      { modul: "takip-ac" },
      {
        modul: "takip-listesi",
        cocuklar: [
          { modul: "takip-bilgisi" },
          {
            modul: "borclular",
            cocuklar: [
              { modul: "borclular-haciz" },
              { modul: "borclular-satis" },
              { modul: "borclular-tebligat" },
              { modul: "borclular-borclu-vekili" },
            ],
          },
          { modul: "takip-alacaklar-goruntule" },
          {
            modul: "takip-kapak-hesabi-goruntule",
            cocuklar: [
              { modul: "kapak-hesabi-masraf-harc" },
              { modul: "kapak-hesabi-tahsilat-taksit" },
            ],
          },
          { modul: "takip-dokuman" },
          { modul: "takip-notlari-goruntule" },
          { modul: "alacaklilar" },
        ],
      },
      {
        modul: "tercihler-modulu",
        cocuklar: [
          { modul: "tercihler-takip-durumlari" },
          { modul: "tercihler-takip-alt-tipleri" },
          { modul: "tercihler-takip-ek-alanlari" },
          { modul: "tercihler-alt-tahsilat-turleri" },
          { modul: "tercihler-not-sablonlari" },
          { modul: "tercihler-faiz-turleri" },
          { modul: "tercihler-masraf-cesitleri" },
          { modul: "tercihler-vekalet-ucretleri" },
          { modul: "tercihler-harclar" },
          { modul: "tercihler-not-ayarlari" },
        ],
      },
      { modul: "faiz-hesaplama-modulu" },
      { modul: "toplu-xml-indir" },
    ],
  },
  {
    urun: "ortak",
    baslik: "Ortak Kayıt İzinleri",
    dugumler: [
      { modul: "ortak-adres" },
      { modul: "ortak-iletisim" },
      { modul: "ortak-banka-hesabi" },
      { modul: "ortak-dokuman" },
      { modul: "ortak-vekalet-kaydi" },
    ],
  },
];

/**
 * Ağaçtaki tüm modül anahtarlarını düz liste olarak döndürür (matris tamamı = 49).
 * ÖZYİNELEMELİ: alt başlıkların alt başlıklarını da (n-seviye) kapsar.
 */
export function tumModulAnahtarlari(): string[] {
  const anahtarlar: string[] = [];
  const yuru = (dugumler: ModulDugumu[]) => {
    dugumler.forEach((dugum) => {
      anahtarlar.push(dugum.modul);
      yuru(dugum.cocuklar || []);
    });
  };
  MODUL_AGACI.forEach((grup) => yuru(grup.dugumler));
  return anahtarlar;
}
